export default __webpack_public_path__ + "static/media/Exit.2e60c20e.png";